import StepSell_1 from "../step_1";

const getBaseSteps = () => {
  // начало визарда
  return [<StepSell_1 />, ];
};
export default getBaseSteps;